export default __webpack_public_path__ + "static/media/arrow-left.e7bc0162.svg";